export const totalPriceExpense=(arr)=>{
    let sum=0;
    arr.forEach((item,index)=>{
        sum+=item.amount
    })
    return sum?.toFixed(2);
}